import DOMPurify from 'dompurify';
export const HtmlRenderer = ({ html }) => {
    const clean = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
            'h1', 'h2', 'h3', 'h4', 'p', 'ul', 'ol', 'li',
            'strong', 'em', 'br', 'span', 'small', 'code', 'hr'
        ],
        ALLOWED_ATTR: ['class']
    });

    return <div className="html-content" dangerouslySetInnerHTML={{ __html: clean }} />;
};